import { render, staticRenderFns } from "./forgot.vue?vue&type=template&id=55a9c7f3"
import script from "./forgot.vue?vue&type=script&lang=js"
export * from "./forgot.vue?vue&type=script&lang=js"
import style0 from "./forgot.vue?vue&type=style&index=0&id=55a9c7f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AccountForgotViewsDefault: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/account/forgot/views/Default.vue').default,AccountSigninContainer: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/account/signin/Container.vue').default})
